// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DCagw","applianceTypes":"styles_applianceTypes__0H-iW","applianceType":"styles_applianceType__W+az8"};